import { render, staticRenderFns } from "./danmuku.vue?vue&type=template&id=06e39b7a"
import script from "./danmuku.vue?vue&type=script&lang=js"
export * from "./danmuku.vue?vue&type=script&lang=js"
import style0 from "./danmuku.vue?vue&type=style&index=0&id=06e39b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports